import { MainApi } from "./MainApi";
import { PartnerCompanySearchCondition } from "../types/partnerCompany";

export class PartnerCompanyApi {
  static baseUrl = `${MainApi.urlPrefix}/user/partner-companies`;

  static getPartnerCompanies = (condition: PartnerCompanySearchCondition) => () =>
    MainApi.api.get(`${PartnerCompanyApi.baseUrl}${MainApi.toParamStringFromObject(condition)}`);
}
